import React, { createContext, useContext, useState } from 'react'

interface DebtsContextData {
  setFilters: React.Dispatch<React.SetStateAction<any>>
  filters: any
}

export const DebtsContext = createContext<DebtsContextData>(
  {} as DebtsContextData
)

export const DebtsProvider: React.FC = ({ children }) => {
  const [filters, setFilters] = useState<any>({})

  return (
    <DebtsContext.Provider
      value={{
        setFilters,
        filters
      }}
    >
      {children}
    </DebtsContext.Provider>
  )
}

export function useDebtsContext() {
  return useContext(DebtsContext)
}
